<template>
  <div id="app">
    <router-view/>
    
    <!-- 消息通知悬浮按钮 -->
    <div class="message-notification-float" @click="goToNotice">
      <el-tooltip content="消息提醒" placement="left">
        <el-badge :value="totalUnreadCount" :hidden="!hasUnreadNotice" :max="99">
          <el-button type="warning" icon="el-icon-bell" circle size="medium"></el-button>
        </el-badge>
      </el-tooltip>
    </div>
    
    <!-- 悬浮客服按钮 -->
    <div class="customer-service-float" @click="openCustomerService">
      <el-tooltip content="咨询客服" placement="left">
        <el-button type="primary" icon="el-icon-service" circle size="medium"></el-button>
      </el-tooltip>
    </div>
    
    <!-- 客服聊天弹窗 -->
    <ChatPopup ref="chatPopup" :dialogVisible="showChatDialog" :userUid="currentChatUid || customerServiceUid" @update:dialogVisible="showChatDialog = $event" @chat-unread-changed="handleChatUnreadChanged" />
   
  </div>
</template>

<script>
import { getUserReceiveNoticeCount, readUserReceiveNoticeCount } from '@/api/notice'
import { getCookie } from '@/utils/cookieUtils'
import webSocketManager from '@/utils/WebSocketManager'
import ChatPopup from '@/components/ChatPopup/index.vue'

export default {
  name: 'App',
  components: {
    ChatPopup
  },
  data() {
    return {
      showChatDialog: false,
      customerServiceUid: '01a4f274c92ecafe6018e9ec1d7caee0', // 默认客服用户ID
      currentChatUid: null, // 当前聊天对象的用户ID
      isLogin: false,
      userReceiveCommentCount: 0,
      userReceiveSystemCount: 0,
      userReceiveWatchCount: 0,
      userReceivePraiseCount: 0,
      chatUnreadCount: 0,
      hasUnreadNotice: false
    }
  },
  computed: {
    totalUnreadCount() {
      return this.userReceiveCommentCount + this.userReceiveSystemCount + this.userReceiveWatchCount + this.userReceivePraiseCount + this.chatUnreadCount
    }
  },
  created() {
    this.checkLoginStatus()
    this.setUserReceiveCommentCount()
    
    // 注册全局聊天框打开方法
    this.$root.$openChatDialog = this.openChatDialog
    this.$root.$openCustomerService = this.openCustomerService
    
    // 监听登录状态变化
    this.$store.watch(
      (state) => state.user.isLogin,
      (newVal, oldVal) => {
        if (newVal && !oldVal) {
          // 用户登录，建立WebSocket连接
          this.$initGlobalWebSocket()
        } else if (!newVal && oldVal) {
          // 用户登出，断开WebSocket连接
          this.$disconnectGlobalWebSocket()
        }
      }
    )
  },
  mounted() {
    // 页面加载时检查登录状态
    if (this.$store.state.user.isLogin && getCookie('token')) {
      this.$initGlobalWebSocket()
    }
    // 注册WebSocket消息处理器
    this.registerWebSocketHandlers()
  },
  beforeDestroy() {
    // 移除WebSocket消息处理器
    this.unregisterWebSocketHandlers()
  },
  methods: {
    checkLoginStatus() {
      this.isLogin = this.$store.state.user.isLogin
    },
    setUserReceiveCommentCount() {
      getUserReceiveNoticeCount().then((response) => {
        
        if (response.code == this.$ECode.SUCCESS) {
          this.userReceiveCommentCount = response.data.userReceiveCommentCount || 0
          this.userReceiveSystemCount = response.data.userReceiveSystemCount || 0
          this.userReceiveWatchCount = response.data.userReceiveWatchCount || 0
          this.userReceivePraiseCount = response.data.userReceivePraiseCount || 0
          this.hasUnreadNotice = this.userReceiveCommentCount > 0 || this.userReceiveSystemCount > 0 || this.userReceiveWatchCount > 0 || this.userReceivePraiseCount > 0
          console.log('消息数量统计 - 评论:', this.userReceiveCommentCount, '系统:', this.userReceiveSystemCount, '关注:', this.userReceiveWatchCount, '点赞:', this.userReceivePraiseCount, '有未读:', this.hasUnreadNotice)
        }
      }).catch(error => {
        console.error('获取消息数量失败:', error)
      })
    },
    openCustomerService() {
      this.currentChatUid = null // 重置为默认客服
      this.showChatDialog = true
    },
    
    /**
     * 打开聊天框
     * @param {string} userUid - 用户ID，如果为null则使用默认客服ID
     */
    openChatDialog(userUid = null) {
      this.currentChatUid = userUid
      this.showChatDialog = true
    },
    goToNotice() {
      // 验证登录状态
      const token = getCookie("token");
      if (!token) {
        this.$message.warning('请先登录后再查看消息通知')
        this.$router.push({ path: "/login" })
        return
      }
      
      // 如果有未读消息，先标记为已读
      if (this.hasUnreadNotice) {
        this.readNotice();
      }

       // 清空聊天未读计数并通知ChatPopup组件
      if (this.chatUnreadCount > 0) {
        this.chatUnreadCount = 0;
        // 通知ChatPopup组件清空其内部状态
        if (this.$refs.chatPopup) {
          this.$refs.chatPopup.clearAllUnreadCounts();
        }
        console.log('已清空聊天未读计数');
      }
      
      
      // 根据消息类型动态跳转到对应的通知页面
      let noticeType = "1"; // 默认跳转到评论通知
      
      // 优先级：评论 > 关注 > 点赞 > 系统
      if (this.userReceiveCommentCount > 0) {
        noticeType = "1"; // 评论通知
      } else if (this.userReceiveWatchCount > 0) {
        noticeType = "2"; // 关注通知
      } else if (this.userReceivePraiseCount > 0) {
        noticeType = "3"; // 点赞通知
      } else if (this.userReceiveSystemCount > 0) {
        noticeType = "4"; // 系统通知
      }
      
      console.log('跳转到通知类型:', noticeType)
      
      // 在新标签页打开通知页面
      let routeData = this.$router.resolve({ path: "/notice", query: { noticeType: noticeType } })
      window.open(routeData.href, '_blank')
    },
    
    // 标记消息为已读状态
    readNotice() {
      readUserReceiveNoticeCount().then((response) => {
        if (response.code == this.$ECode.SUCCESS) {
          // 阅读成功，清零所有消息计数
          this.userReceiveCommentCount = 0;
          this.userReceivePraiseCount = 0;
          this.userReceiveSystemCount = 0;
          this.userReceiveWatchCount = 0;
          this.hasUnreadNotice = false;
          console.log('消息已标记为已读，计数已清零');
        }
      }).catch(error => {
        console.error('标记消息已读失败:', error);
      });
    },
    
    /**
     * 刷新用户信息
     */
    refreshUserInfo() {
      const token = getCookie("token");
      if (!token) {
        console.warn("[refreshUserInfo] token不存在，无法刷新用户信息");
        return;
      }
      
      console.log("[refreshUserInfo] 开始刷新用户信息");
      
      // 重新验证token并获取最新用户信息
      import('@/api/user.js').then(({ authVerify }) => {
        authVerify(token).then(response => {
          if (response && response.code === this.$ECode.SUCCESS) {
            const userInfo = response.data;
            
            // 验证会员状态
            if (userInfo.vipDeadlineTime) {
              const now = new Date();
              const deadlineTime = new Date(userInfo.vipDeadlineTime);
              userInfo.isVip = deadlineTime > now;
              console.log('[refreshUserInfo] 会员状态检查:', '截止时间:', userInfo.vipDeadlineTime, '是否会员:', userInfo.isVip);
            } else {
              userInfo.isVip = false;
              console.log('[refreshUserInfo] 会员状态检查: 无截止时间，非会员');
            }
            
            // 更新全局用户信息
            this.$store.commit('setUserInfo', userInfo);
            this.$store.commit('setLoginState', true);
            
            console.log("[refreshUserInfo] 用户信息刷新完成:", userInfo);
            
            // 触发全局事件，通知其他组件更新用户信息
            this.$bus && this.$bus.$emit('user-info-updated', userInfo);
            
            this.$message.success('会员状态已更新！');
          } else {
            console.error("[refreshUserInfo] 获取用户信息失败:", response);
            this.$message.warning('用户信息刷新失败');
          }
        }).catch(error => {
          console.error("[refreshUserInfo] 刷新用户信息异常:", error);
          this.$message.warning('用户信息刷新失败');
        });
      });
    },
    
    // 处理聊天未读数变化
    handleChatUnreadChanged(unreadCount) {
      this.chatUnreadCount = unreadCount || 0;
      // 更新hasUnreadNotice状态
      this.hasUnreadNotice = this.totalUnreadCount > 0;
      console.log('聊天未读数更新:', unreadCount, '总未读数:', this.totalUnreadCount);
    },
    
    /**
     * 注册WebSocket消息处理器
     */
    registerWebSocketHandlers() {
      // 监听所有消息，但在处理函数中过滤，只处理领域事件
      webSocketManager.onMessage('*', this.handleDomainEvent, 'app-domain-event')
    },
    
    /**
     * 移除WebSocket消息处理器
     */
    unregisterWebSocketHandlers() {
      webSocketManager.offMessage('*', 'app-domain-event')
    },
    
    /**
     * 处理领域事件
     */
    handleDomainEvent(messageVo) {
      // 只处理领域事件，忽略聊天消息（category: 20001）
      if (messageVo.messageLevel && messageVo.messageLevel === 40010) {
        console.log('App接收领域事件', messageVo)
        
        switch (messageVo.message) {
          case 'COMMENT_NOTICE':
            {
              // 评论通知
              console.log('App收到评论通知，刷新通知计数')
              this.setUserReceiveCommentCount()
            }
            break
          case 'FOLLOW_NOTICE':
            {
              // 关注通知
              console.log('App收到关注通知，刷新通知计数')
              this.setUserReceiveCommentCount()
            }
            break
          case 'PRAISE_NOTICE':
            {
              // 点赞通知
              console.log('App收到点赞通知，刷新通知计数')
              this.setUserReceiveCommentCount()
            }
            break
          case 'PAY_SUCCESS':
            {
              // 支付成功，刷新用户信息
              console.log('App收到支付成功通知，刷新用户信息')
              this.refreshUserInfo()
            }
            break
        }
      }
    }
  }
  
  // 移除beforeDestroy钩子，WebSocket连接现在由全局登录状态监听统一管理
}
</script>

<style>
/* 消息通知悬浮按钮样式 */
.message-notification-float {
  position: fixed;
  bottom: 100px;
  right: 30px;
  z-index: 9999;
  cursor: pointer;
  animation: float 3s ease-in-out infinite;
}

.message-notification-float .el-button {
  width: 60px;
  height: 60px;
  box-shadow: 0 4px 12px rgba(230, 162, 60, 0.3);
  transition: all 0.3s ease;
}

.message-notification-float .el-button:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(230, 162, 60, 0.5);
}

/* 悬浮客服按钮样式 */
.customer-service-float {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 9999;
  cursor: pointer;
  animation: float 3s ease-in-out infinite;
}

.customer-service-float .el-button {
  width: 60px;
  height: 60px;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
  transition: all 0.3s ease;
}

.customer-service-float .el-button:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(64, 158, 255, 0.5);
}

/* 悬浮动画 */
@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .message-notification-float {
    bottom: 80px;
    right: 20px;
  }
  
  .message-notification-float .el-button {
    width: 50px;
    height: 50px;
  }
  
  .customer-service-float {
    bottom: 20px;
    right: 20px;
  }
  
  .customer-service-float .el-button {
    width: 50px;
    height: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue